import React from 'react'
import { Modal } from 'react-bootstrap'

// v3.2: Yöntem seçim modalı — precheck geçtikten sonra açılır.
// Kullanıcı "Temassız Giriş" (BLE/Konum) veya "QR ile Giriş" seçer.
const BarrierMethodModal = ({ open, direction, onClose, onContactless, onQr, isBusy = false }) => {
  const directionLabel = direction === 'exit' ? 'Çıkış' : 'Giriş'

  return (
    <Modal show={open} onHide={onClose} centered contentClassName='border-radius-0'>
      <Modal.Body style={{ padding: '1.8rem 1.4rem' }}>
        <div className='text-center mb-3'>
          <h5 style={{ fontWeight: 700, color: '#205C42', marginBottom: 4 }}>
            {directionLabel} Yöntemi Seçin
          </h5>
          <p style={{ fontSize: 13, color: '#666', margin: 0 }}>
            Bariyerin açılması için iki yöntemden size uygun olanı tercih edin.
          </p>
        </div>

        <button
          type='button'
          onClick={onContactless}
          disabled={isBusy}
          style={{
            width: '100%',
            background: 'linear-gradient(0.65turn, #77DBEB, #1681B1)',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            padding: '1rem',
            marginBottom: '0.8rem',
            fontSize: 15,
            fontWeight: 600,
            cursor: isBusy ? 'not-allowed' : 'pointer',
            opacity: isBusy ? 0.6 : 1,
          }}
        >
          {`Temassız ${directionLabel}`}
          <div style={{ fontSize: 12, fontWeight: 400, marginTop: 3, opacity: 0.9 }}>
            Bluetooth + Konum ile otomatik doğrulama
          </div>
        </button>

        <button
          type='button'
          onClick={onQr}
          disabled={isBusy}
          style={{
            width: '100%',
            background: 'linear-gradient(0.65turn, #86C2A8, #205C42)',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            padding: '1rem',
            fontSize: 15,
            fontWeight: 600,
            cursor: isBusy ? 'not-allowed' : 'pointer',
            opacity: isBusy ? 0.6 : 1,
          }}
        >
          {`QR ile ${directionLabel}`}
          <div style={{ fontSize: 12, fontWeight: 400, marginTop: 3, opacity: 0.9 }}>
            Telefon QR'ını bariyer okuyucusuna gösterin
          </div>
        </button>

        <button
          type='button'
          onClick={onClose}
          disabled={isBusy}
          style={{
            width: '100%',
            background: 'transparent',
            color: '#888',
            border: 'none',
            padding: '0.8rem',
            marginTop: '0.6rem',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Vazgeç
        </button>
      </Modal.Body>
    </Modal>
  )
}

export default BarrierMethodModal
